import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentCalculationMethodEnum } from '@zaoblako/shared/modules/document/enums/document.calculation.method.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { DocumentCalculationMethodNamePipe } from '@zaoblako/web/shared/pipes/document-calculation-method-name.pipe';

@Component({
  standalone: true,
  selector: 'crm-document-calculation-method-single-select',
  templateUrl: './document-calculation-method-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent, DocumentCalculationMethodNamePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentCalculationMethodSingleSelectComponent {
  @Input() public documentMethod: DocumentCalculationMethodEnum;
  @Output() public documentMethodChange = new EventEmitter<DocumentCalculationMethodEnum>();

  @Input() public styleClass: string;
  @Input() public showClear = false;
  @Input() public appendTo: string;
  @Input() public disabled = false;

  @Input() public isError = false;

  public methodTypes = Object.values(DocumentCalculationMethodEnum);
}
